module.exports = __webpack_public_path__ + "static/media/cheeky-tiki.02278cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/cheeky-tiki.png
// module id = 1367
// module chunks = 1